import { translate } from 'components/Translation';
import { BodyS } from 'components/Typography/Typography';
import ConfirmationDialog from 'components/ConfirmationDialog/ConfirmationDialog';
import extendRoamingInternational from './extendRoamingInternational';
import idConfig from 'utils/ecommerce/services/id.config';
import React, { useMemo } from 'react';

enum ServiceType {
	JAWAZAK = 'JAWAZAK',
	GOBIZ = 'GOBIZ',
	INTERNATIONAL = 'INTERNATIONAL',
}
interface IRoamingInternationalActivationDialog {
	isOpen: boolean;
	hideDialog: () => void;
	type: ServiceType;
	internationalPackage: types.services.IPackageDetails;
	roamingPackage: types.services.IPackageDetails;
	updateOrderItems: types.services.updateOrderItemsFunction;
	isPending?: boolean;
}

const RoamingInternationalActivationDialog = ({
	isOpen,
	hideDialog,
	type,
	updateOrderItems,
	internationalPackage,
	roamingPackage,
	isPending,
}: IRoamingInternationalActivationDialog) => {
	const activate = () => {
		const orderItems: types.services.IOrderItem[] = [];
		let serviceName: string = '';
		if (type === 'INTERNATIONAL') {
			// activate only international
			serviceName = translate('number.services.international');
			orderItems.push({
				...internationalPackage,
				action: 'ADD',
				id: idConfig.INTERNATIONAL.legacyProductId,
			});
		} else if (type === 'JAWAZAK' || type === 'GOBIZ') {
			// activate roaming + international
			serviceName = translate('number.services.international.roaming');
			orderItems.push(
				{
					...internationalPackage,
					action: 'ADD',
					id: idConfig.INTERNATIONAL.legacyProductId,
				},
				{
					...roamingPackage,
					action: 'ADD',
					id: idConfig.ROAMING.legacyProductId,
				}
			);
		}
		hideDialog();
		updateOrderItems(orderItems, 'TURN_ON', serviceName);
	};

	const header = useMemo(() => {
		if (type === 'INTERNATIONAL') {
			return translate('number.services.international.required');
		}
		return translate('number.services.roaming.required');
	}, [type]);

	const description = useMemo(() => {
		if (type === 'INTERNATIONAL') {
			return isPending
				? translate('number.services.international.minutes.international.required.description.pending')
				: translate('number.services.international.minutes.international.required.description');
		}
		return isPending
			? translate('number.services.roaming.required.description.pending')
			: translate(`number.services.${type}.roaming.required.description`);
	}, [type, isPending]);

	return (
		<ConfirmationDialog
			isOpen={isOpen}
			hideDialog={hideDialog}
			header={header}
			dialogBody={
				<div>
					<BodyS color="primary-light">{description}</BodyS>
				</div>
			}
			buttons={[
				{
					text: translate('cancel'),
					onClick: hideDialog,
					color: 'tertiary-light',
				},
				{
					text: translate('turnOn'),
					onClick: activate,
					color: 'primary-light',
					disabled: isPending,
				},
			]}
		/>
	);
};

export default extendRoamingInternational(RoamingInternationalActivationDialog);
